module.exports = "<div class=\"row\">\n\t<div class=\"col-xs-12\">\n\n\t\t<div ui-grid-pagination ui-grid-resize-columns\n\t\tui-grid=\"uiGridCtrl.uiGrid\" ng-if=\"!uiGridCtrl.inEdit\"\n\t\tng-if=\"uiGridCtrl.uiGrid.data\"></div>\n\n\t\t<div ui-grid-pagination ui-grid-resize-columns ui-grid-selection\n\t\tui-grid=\"uiGridCtrl.uiGrid\" ng-if=\"uiGridCtrl.inEdit\"\n\t\tng-if=\"uiGridCtrl.uiGrid.data\"></div>\n\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui-grid-component/ui-grid-component.html
// module id = 261
// module chunks = 0